import React from "react";

import { Currency } from "../../features/auth/store/types/currency-types";

type CurrencyListProps = {
  items: Currency[];
  loading?: boolean;
  onEdit?: (item: Currency) => void;
  onDelete?: (item: Currency) => void;
};

export const CurrencyTable: React.FC<CurrencyListProps> = ({
  items,
  loading,
  onEdit,
  onDelete,
}) => {
  const hasItems = items && items.length > 0;

  return (
    <div className="overflow-x-auto bg-white rounded-lg border border-gray-200">
      <table className="min-w-full text-left">
        <thead className="bg-gray-50 text-xs uppercase text-gray-500">
          <tr>
            <th className="px-4 py-3 font-semibold">Name</th>
            <th className="px-4 py-3 font-semibold">Code</th>
            <th className="px-4 py-3 font-semibold">Symbol</th>
            <th className="px-4 py-3 font-semibold">Exchange Rate</th>
            <th className="px-4 py-3 font-semibold text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {loading ? (
            <tr>
              <td colSpan={5} className="px-4 py-6 text-center">
                <div className="flex items-center justify-center h-full">
                  <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
                </div>
              </td>
            </tr>
          ) : hasItems ? (
            items.map((currency) => (
              <tr key={currency.id} className="text-sm text-gray-800">
                <td className="px-4 py-3">{currency.name}</td>
                <td className="px-4 py-3">{currency.code || "-"}</td>
                <td className="px-4 py-3 font-semibold">{currency.symbol}</td>
                <td className="px-4 py-3">
                  {Number(currency.exchange_rate).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 6,
                  })}
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <button
                      className="px-3 py-1 rounded bg-yellow-50 text-yellow-700 border border-yellow-200"
                      onClick={() => onEdit?.(currency)}
                    >
                      Edit
                    </button>
                    <button
                      className="px-3 py-1 rounded bg-red-50 text-red-700 border border-red-200"
                      onClick={() => onDelete?.(currency)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={5}
                className="px-4 py-6 text-center text-sm text-gray-500"
              >
                No currencies available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
